import React from "react";

import OverviewContainer from "../../../../../container/overview";
import { ESupplyChainOverviewTabs } from "../../../../../models/supply.chain.overview.configure";

const ProductsOverviewPanel = () => {
  return <OverviewContainer panel={ESupplyChainOverviewTabs.PRODUCTS} />;
};

export default ProductsOverviewPanel;
